import { classNames, twMerge } from '@panwds/tailwindcss';
export const navItemV3Theme = {
    appearance: {
        red: 'twds-bg-red-500',
        blue: 'twds-bg-blue-600',
        teal: 'twds-bg-teal-500',
        lightBlue: 'twds-bg-blue-200'
    },
    dot: {
        root: {
            base: 'twds-box-border twds-h-3 twds-w-3',
            position: 'twds-absolute twds-right-3 twds-top-1.5',
            border: 'twds-round twds-rounded-full',
            spacing: 'twds-ml-1',
            zIndex: 'twds-z-20'
        },
        withValue: {
            base: 'twds-box-border twds-w-4 twds-h-4 twds-flex twds-justify-center',
            position: 'twds-absolute twds-right-2 twds-top-1',
            border: 'twds-rounded',
            text: 'twds-text-xs twds-leading-4',
            textColor: 'twds-text-steel-gray-100',
            spacing: 'twds-ml-1',
            zIndex: 'twds-z-20'
        }
    },
    title: {
        wrap: {
            base: 'twds-box-border twds-flex twds-flex-grow twds-items-center twds-justify-between',
            spacing: 'twds-ml-5 twds-mr-2',
            textColor: 'twds-text-steel-gray-400',
            textOverflow: 'twds-overflow-hidden',
            zIndex: 'twds-z-10'
        },
        text: {
            textOverflow: 'twds-truncate',
            textColor: 'group-hover:twds-text-steel-gray-100'
        }
    },
    collapseIcon: {
        position: 'twds-absolute twds-right-2 group-hover:twds-translate-x-[2px] group-hover:twds-transition-transform group-hover:twds-duration-[180ms] group-hover:twds-ease-in-out'
    },
    icon: {
        base: 'twds-box-border',
        color: 'twds-text-steel-gray-400',
        fill: 'twds-fill-steel-gray-400',
        spacing: 'twds-p-0',
        hover: 'group-hover:twds-fill-steel-gray-100',
        zIndex: 'twds-z-10'
    },
    iconWrap: {
        base: 'twds-flex-shrink-0 twds-flex twds-items-center',
        match: 'twds-nav-text-selected-icon twds-rounded'
    },
    list: {
        root: {
            base: 'twds-flex twds-flex-col twds-min-h-0',
            spacing: 'twds-my-1'
        },
        tooltip: {
            base: 'twds-w-12',
            spacing: 'twds-mx-2'
        }
    },
    tabButton: {
        base: 'twds-flex twds-items-center twds-h-9 twds-group',
        text: 'twds-text-sm twds-font-lato',
        position: 'twds-relative',
        spacing: 'twds-m-0 twds-pl-4 twds-py-2',
        border: 'twds-rounded twds-border-0 hover:twds-border-solid hover:twds-rounded',
        background: 'twds-bg-transparent active:twds-bg-steel-gray-600',
        disabled: 'twds-opacity-60 twds-cursor-not-allowed active:twds-bg-transparent',
        cursor: 'twds-cursor-pointer',
        match: 'twds-bg-steel-gray-700',
        visit: 'twds-bg-steel-gray-800',
        hoverAnimation: {
            base: 'twds-relative twds-overflow-hidden',
            pseudo: 'before:twds-content-[""] before:twds-absolute before:twds-inset-0 before:twds-bg-steel-gray-800 before:twds-opacity-0 before:twds-transition-all before:twds-ease-in before:twds-scale-0 before:twds-z-0',
            outDelay: 'before:twds-duration-[300ms]',
            outDelayCollapsed: 'before:twds-duration-[100ms]',
            originLeft: 'before:twds-origin-left',
            originCenter: 'before:twds-origin-center',
            hover: 'hover:before:twds-opacity-100 hover:before:twds-scale-100 before:hover:twds-transition-[200ms]'
        }
    }
};
/** NavItemV3 classes */
export function getNavItemDotClasses(dotValue, appearanceClass) {
    const dotClasses = classNames(navItemV3Theme.dot.root.base, navItemV3Theme.dot.root.position, navItemV3Theme.dot.root.border, navItemV3Theme.dot.root.spacing, navItemV3Theme.dot.root.zIndex, appearanceClass);
    const dotValueClasses = classNames(navItemV3Theme.dot.withValue.base, navItemV3Theme.dot.withValue.position, navItemV3Theme.dot.withValue.border, navItemV3Theme.dot.withValue.text, navItemV3Theme.dot.withValue.textColor, navItemV3Theme.dot.withValue.spacing, navItemV3Theme.dot.withValue.zIndex, appearanceClass);
    return !dotValue ? dotClasses : dotValueClasses;
}
export function getNavItemTitleTextClasses(match, disabled) {
    return classNames(navItemV3Theme.title.text.textOverflow, !disabled && navItemV3Theme.title.text.textColor, match && 'twds-text-steel-gray-100');
}
export function getNavItemIconClass(match, brandColorClass, currentVisit, disabled) {
    return classNames(navItemV3Theme.icon.base, navItemV3Theme.icon.color, navItemV3Theme.icon.fill, navItemV3Theme.icon.spacing, navItemV3Theme.icon.zIndex, match && brandColorClass, !match && !disabled && navItemV3Theme.icon.hover, currentVisit && 'twds-fill-steel-gray-200');
}
export function getNavListClasses(className) {
    return twMerge(navItemV3Theme.list.root.base, navItemV3Theme.list.root.spacing, className);
}
export function getNavItemIconWrapClasses(match) {
    return classNames(navItemV3Theme.iconWrap.base, match && navItemV3Theme.iconWrap.match);
}
export function getNavItemCaretRightIconClass(iconClass, match, collapsed) {
    return classNames(navItemV3Theme.collapseIcon.position, collapsed && 'twds-right-1', iconClass, !match && 'twds-fill-[#69737A]');
}
export function getNavItemListTooltipClasses() {
    return classNames(navItemV3Theme.list.tooltip.base, navItemV3Theme.list.tooltip.spacing);
}
// Animation classes
export const getHoverAnimationClasses = (match, collapsed, disabled) => {
    if (match || disabled)
        return '';
    return [
        navItemV3Theme.tabButton.hoverAnimation.base,
        navItemV3Theme.tabButton.hoverAnimation.pseudo,
        navItemV3Theme.tabButton.hoverAnimation.outDelay,
        !collapsed && navItemV3Theme.tabButton.hoverAnimation.originLeft,
        collapsed && navItemV3Theme.tabButton.hoverAnimation.originCenter,
        collapsed && navItemV3Theme.tabButton.hoverAnimation.outDelayCollapsed,
        navItemV3Theme.tabButton.hoverAnimation.hover
    ].filter(Boolean);
};
export function getTabButtonClass(disabled, match, currentVisit, isBottomNav, className, leftNavCollapsed) {
    return twMerge(navItemV3Theme.tabButton.base, navItemV3Theme.tabButton.cursor, navItemV3Theme.tabButton.text, navItemV3Theme.tabButton.position, navItemV3Theme.tabButton.spacing, navItemV3Theme.tabButton.border, navItemV3Theme.tabButton.background, disabled && navItemV3Theme.tabButton.disabled, leftNavCollapsed ? 'twds-pr-1' : 'twds-pr-4', match && navItemV3Theme.tabButton.match, isBottomNav && match && 'twds-bg-steel-gray-950', currentVisit && navItemV3Theme.tabButton.visit, ...getHoverAnimationClasses(match, leftNavCollapsed, disabled), className);
}
export function getTitleWrapClasses() {
    return classNames(navItemV3Theme.title.wrap.base, navItemV3Theme.title.wrap.spacing, navItemV3Theme.title.wrap.textColor, navItemV3Theme.title.wrap.textOverflow, navItemV3Theme.title.wrap.zIndex);
}
//# sourceMappingURL=navItemV3.logic.js.map